import { render, staticRenderFns } from "./AccessAppCustomerServiceFields.vue?vue&type=template&id=653136d6&scoped=true&"
import script from "./AccessAppCustomerServiceFields.vue?vue&type=script&lang=js&"
export * from "./AccessAppCustomerServiceFields.vue?vue&type=script&lang=js&"
import style0 from "./AccessAppCustomerServiceFields.vue?vue&type=style&index=0&id=653136d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653136d6",
  null
  
)

export default component.exports